export default {
  statusOk: 'OK',
  statusWarning: 'WARNING',
  sftpStatus: 'SFTP Status',
  checkInterval: 'Check Interval',
  lastCheck: 'Last Check',
  lastSuccessfullStatus: 'Last Successfull Status',
  includingZeroKbFiles: 'including "0 kb" files',
};
